import { SESSION_STORAGE_HOME_ROUTE_INFO_KEY } from '@/constants/sessionStorage'

export default function getHomePageRouteInfo() {
    return JSON.parse(
        sessionStorage.getItem(SESSION_STORAGE_HOME_ROUTE_INFO_KEY)
    )
}
